export default class BaseGlossarySearch {

    /**
     * @var {boolean}
     */
    isLoading = false; 

    /**
     * @var {boolean}
     */
    updateHistory = true;

    /**
     * @var {string}
     */
    search = '';

    /**
     * @var {boolean}
     */
    isSearching = false;
    

    init() {
        const url = new URL(window.location.href);
        const search = new URLSearchParams(url.search);
        this.search = search.get('search') || '';

        if(this.search){
            this.isSearching = true;
        }

    }

    /**
     * fetchContent
     * 
     * Description: Requests the new post grid based on the current 
     * filters and replaces the current post grid with it's content.
     * 
     * @param {string} href
     * @return void
     */
    searchItems(){
        // Get the post grid container and the data selector for the post grid.
        const elements = ['data-pegasus-filterable="glossary-section"'];
        let currentUrl = '';

        // If there are no filters, just refresh the page.
        if(!this.search.length){
            currentUrl = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
            this.isSearching = false;
        } else {
            // If there are filters, build the url and set it as the current url.
            currentUrl = window.location.href = window.location.protocol + '//' + window.location.hostname + window.location.pathname + '?search=' + this.search; 
            this.isSearching = true;
        }

        
        // Only allow a request to happen whilst we're not waiting for a response.
        if(!this.isLoading){
            this.isLoading = true;

            // Run the ajaxContent function from pegasus.
            pegasus.ajaxContent(currentUrl, elements, {}, () => {
                this.isLoading = false;

                // Update the url with the current filters.
                history.pushState({ path: currentUrl }, 'Glossary', currentUrl);

                // If the post grid items open in modals make sure to re-initialise them.
                if(typeof window.modal !== "undefined"){
                    window.modal.init();
                }

            });
        }
    }

}

document.addEventListener('alpine:init', () => {
    Alpine.data('glossarySearch', () => new BaseGlossarySearch());
});